<template>
  <div class="item" id="pg-medias">
    <div class="left" data-toggle="collapse" data-target="#item-medias" aria-expanded="true" aria-controls="item-medias">
      <p class="text-add-course">Mídias</p>
    </div>
    <div id="item-medias" class="text-center rigth collapse width"  aria-labelledby="pg-medias" data-parent="#pg-add-course">
      <div class="content-info">
        <div class="form-info text-left">
          <media-item title="Imagem de Capa" modal="uploadCoverClassModal" class="mb-2" @setItemValue="setCover" :itemDefault="medias.cover" />
          <media-item title="Miniatura" modal="uploadThumbnailClassModal" class="mb-2" @setItemValue="setThumbnail" :itemDefault="medias.thumbnail" />
          <media-item title="Vídeo Promocional" modal="uploadVideoClassModal" class="mb-2" @setItemValue="setVideo" :itemDefault="medias.video" />

          <div class="d-flex justify-content-between mt-5">
            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-tags"
              aria-expanded="true"
              aria-controls="item-tags"
            ><< Tags</button>

            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-finish"
              aria-expanded="true"
              aria-controls="item-finish"
            >Finalização >></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaItem from './../../Media/LoadItemMedia'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'add-course-medias',
  data () {
    return {
      item: {}
    }
  },
  components: {
    "media-item": MediaItem
  },
  computed: {
    ...mapGetters({
      medias: "getNewCourseMedias",
    })
  },
  methods: {
    ...mapActions({
      setMedias: "setMedias"
    }),

    setCover: function ( value ) {
      this.item.cover = value
      this.uploadMedias()
    },

    setVideo: function (value ) {
      this.item.video = value
      this.uploadMedias()
    },

    setThumbnail: function (value ) {
      this.item.thumbnail = value
      this.uploadMedias()
    },

    uploadMedias: function () {
      this.setMedias({
        cover: this.item.cover,
        video: this.item.video,
        thumbnail: this.item.thumbnail,
      })
    }
  },
  mounted () {
    this.item = {
      cover: this.medias.cover,
      video: this.medias.video,
      thumbnail: this.medias.thumbnail,
    }
  }
}
</script>
